var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeatbelt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(-313.29 -2636.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(27)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(286.29 2636.485)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(-125.049 1476.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436-2",
    "data-name": "Group 436",
    transform: "translate(542 1234.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M98.284,518.029a3.872,3.872,0,0,0,.97-5.606c-2.264-3.557-7.33-12.289-7.33-12.289s-.97-1.94-5.174-3.773-5.174-2.7-7.223-6.145c-.108,0-1.617-4.312-4.743-2.587s-7.654,2.8-5.821,6.468,3.45,4.851,2.911,7.869-2.587,7.223,0,11.319,7.654,12.5,7.654,12.5,1.94,2.372,5.713,0S98.284,518.029,98.284,518.029Z",
    transform: "translate(-41.38 -477.113)",
    fill: "none",
    stroke: "#fffbfb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M157.267,618s-.323,2.372-9.81,5.821S137,630.72,137,630.72",
    transform: "translate(-107.262 -595.409)",
    fill: "none",
    stroke: "#fffbfb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M294.326,409.925s-2.156-1.725,0-3.018,3.342-1.94,3.342-1.94l-1.294-2.048-7.869-2.264s-1.186-1.186-5.39,1.294-7.115,4.42-7.115,4.42l3.234,5.39,5.282-3.018,3.989,4.743Z",
    transform: "translate(-260.274 -400.371)",
    fill: "none",
    stroke: "#fffbfb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M401.528,481s-.431,7.115-4.528,11.1",
    transform: "translate(-377.561 -471.453)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M0,1.294,3.881,0",
    transform: "translate(11.029 10.493) rotate(-171)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M0,1.232,3.482,0",
    transform: "translate(12.454 12.929) rotate(177)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M0,1.232,3.482,0",
    transform: "matrix(-0.875, 0.485, -0.485, -0.875, 13.834, 14.92)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M0,1.294,3.881,0",
    transform: "matrix(-0.999, -0.035, 0.035, -0.999, 3.878, 12.595)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M0,1.333,3.955,0",
    transform: "translate(6.059 16.275) rotate(173)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M0,1.333,3.955,0",
    transform: "translate(8.695 19.649) rotate(161)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "download_6_",
    "data-name": "download (6)",
    d: "M222.3,194.078a3.854,3.854,0,0,0-3.849,3.849v.9c-1.746-.459-3.474-.945-5.17-1.462a16.382,16.382,0,0,0-3.738-9.573l-1.652-1.973a4.208,4.208,0,0,1-.985-2.721c0-.152.01-.3.019-.433a4.277,4.277,0,0,1,.828-2.118l.935-1.243A10.329,10.329,0,0,0,204.5,163.61l-2.729-1.169,0-.436a15.4,15.4,0,1,0-30.79,0v.437l-2.725,1.168a10.358,10.358,0,0,0-5.847,6.709l-8.105-6.372v-.659a3.854,3.854,0,0,0-3.849-3.849h-3.849v20.526h3.849a3.849,3.849,0,0,0,3.842-3.78l8.9,7,.135.1c.69.538,1.39,1.073,2.093,1.606a4.179,4.179,0,0,1-.562.917l-1.659,1.981a16.379,16.379,0,0,0-3.773,10.44,16.192,16.192,0,0,0,1.726,7.28l.186.376a4.165,4.165,0,0,0-2.747,3.9,3.529,3.529,0,0,0,.039.6l1.732,12.163a4.21,4.21,0,0,0,4.145,3.589H208.24a4.209,4.209,0,0,0,4.144-3.591l1.73-12.152a4.174,4.174,0,0,0,0-1.129c1.4.409,2.852.806,4.336,1.187v.291A3.854,3.854,0,0,0,222.3,214.6h3.849V194.077Zm-14.727-4.647a13.832,13.832,0,0,1,3.06,7.088c-2.978-.954-5.945-2-8.86-3.15v-3.577a3.875,3.875,0,0,1,1.125-2.724l1.808-1.808a6.82,6.82,0,0,0,1.215,2.2Zm.615-16.329a7.674,7.674,0,0,1-1.551,4.656l-.938,1.248a6.827,6.827,0,0,0-1.233,2.869l-3.382,3.381a6.452,6.452,0,0,0-1.877,4.536v2.544a146.389,146.389,0,0,1-19.4-9.805h14.78a5.158,5.158,0,0,0,5.081-4.413l1.855-12.992,1.964.842a7.751,7.751,0,0,1,4.7,7.134ZM176.852,179.6a2.584,2.584,0,0,1-1.224-1.839l-.051-.358h21.6l-.051.358a2.578,2.578,0,0,1-2.54,2.208H178.168a2.567,2.567,0,0,1-1.317-.37Zm20.694-4.762H175.21l-.366-2.566h23.067Zm.733-5.132h-23.8l-.733-5.132h25.266Zm-11.9-20.526a12.821,12.821,0,0,1,12.83,12.829H173.548a12.844,12.844,0,0,1,12.829-12.829Zm-17.11,16.792,1.976-.847,1.843,13c.007.051.03.1.039.149-2.871-1.938-5.665-3.973-8.335-6.077l-.135-.106a7.77,7.77,0,0,1,4.612-6.115ZM151.74,176.118a1.284,1.284,0,0,1-1.283,1.283h-1.283v-15.4h1.283a1.284,1.284,0,0,1,1.283,1.283Zm13.44,13.319,1.657-1.978a6.625,6.625,0,0,0,.686-1.014c1.147.832,2.255,1.613,3.321,2.331a3.973,3.973,0,0,1,.139,1.017v18.632a3.833,3.833,0,0,0-2.54,3.36l-1.928-3.843a4.112,4.112,0,0,0-2.293-2.037l-.765-1.541a13.615,13.615,0,0,1-1.455-6.13,13.818,13.818,0,0,1,3.178-8.8Zm39.132,22.35a3.831,3.831,0,0,0-2.54-3.36v-3.31q2.573.994,5.119,1.868a4.169,4.169,0,0,0-.647.951Zm-5.106-3.6H187.66v2.566h12.829a1.284,1.284,0,0,1,1.283,1.283v3.76a1.6,1.6,0,0,1-.513.089H171.495a1.548,1.548,0,0,1-.513-.09V212.04a1.284,1.284,0,0,1,1.283-1.283h12.829v-2.566H173.547V190.585A148.935,148.935,0,0,0,199.2,204.094ZM209.843,222.2a1.629,1.629,0,0,1-1.6,1.39H164.517a1.628,1.628,0,0,1-1.6-1.387l-1.74-12.215a1.185,1.185,0,0,1-.005-.19,1.606,1.606,0,0,1,1.6-1.6.917.917,0,0,1,.211.018l.091.018a1.554,1.554,0,0,1,1.145.859l3.541,7.056a4.046,4.046,0,0,0,1.143,1.4,4.179,4.179,0,0,0,2.595.908h29.765a4.172,4.172,0,0,0,2.579-.894A4.066,4.066,0,0,0,205,216.144l3.545-7.064a1.634,1.634,0,0,1,1.929-.819,1.614,1.614,0,0,1,1.1,1.777Zm1.418-16.475c-3.369-1.044-6.831-2.281-10.293-3.673a146.349,146.349,0,0,1-28.1-14.991c-1.628-1.08-3.3-2.264-5.124-3.615-.961-.717-1.9-1.446-2.834-2.176L154.3,172.928V167.21l8.194,6.435.7.557c3.738,2.945,7.706,5.759,11.789,8.359a148.8,148.8,0,0,0,25.027,12.889c3.807,1.527,7.718,2.908,11.617,4.1,2.218.691,4.51,1.333,6.821,1.929v6.338c-2.517-.66-4.93-1.36-7.189-2.1Zm12.321,6.319H222.3a1.284,1.284,0,0,1-1.283-1.283v-12.83a1.284,1.284,0,0,1,1.283-1.283h1.283Z",
    transform: "translate(318.73 1068.221)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatbelt);
export default __webpack_public_path__ + "static/media/seatbelt.e59b603a447deaf761c0532522322473.svg";
export { ForwardRef as ReactComponent };